import './tradingPairModal.scss';

import { Dispatch, SetStateAction, useCallback } from 'react';

import { Button } from 'ui/Button/Button';
import { Modal } from 'ui/Modal/Modal';
import { RadioBox } from 'ui/RadioBox/RadioBox';
import { EExchange } from 'web3';

type ChoseTradingPairsProps = {
  onClose: () => void;
  openAddPairWindow: () => void;
  openAddSolanaPairWindow: () => void;
  openSelectPairDex: () => void;
  typeTradingPair: EExchange;
  setTypeTradingPair: Dispatch<SetStateAction<EExchange>>;
};

export const TradingPairModal = ({
  onClose,
  openAddPairWindow,
  openAddSolanaPairWindow,
  openSelectPairDex,
  typeTradingPair,
  setTypeTradingPair,
}: ChoseTradingPairsProps) => {
  const handleNext = useCallback(() => {
    if (typeTradingPair === EExchange.cex) {
      openAddPairWindow();
    }
    if (typeTradingPair === EExchange.dex) {
      openSelectPairDex();
    }
    if (typeTradingPair === EExchange.sol) {
      openAddSolanaPairWindow();
    }
  }, [typeTradingPair, openAddPairWindow, openAddSolanaPairWindow, openSelectPairDex]);

  return (
    <Modal
      title="New trading pair"
      onClose={onClose}
      className={'mm-trading-pair-modal'}
      customButtons={<Button onClick={handleNext}>Next</Button>}
    >
      <div className="mm-trading-pair-modal__trading_pair_container">
        <RadioBox
          text={'CEX'}
          checked={typeTradingPair === EExchange.cex}
          onChange={() => setTypeTradingPair(EExchange.cex)}
        />
        <RadioBox
          text={'DEX'}
          checked={typeTradingPair === EExchange.dex}
          onChange={() => setTypeTradingPair(EExchange.dex)}
        />
        <RadioBox
          text={'Solana'}
          checked={typeTradingPair === EExchange.sol}
          onChange={() => setTypeTradingPair(EExchange.sol)}
        />
      </div>
    </Modal>
  );
};
